import { ProposeCalendarEventTimeInput } from '@griply/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { proposeExternalCalendarEventTime } from 'shared/services/backend-api';

import { queryKey as eventQueryKey } from './use-external-calendar-event-query';

export const useProposeExternalCalendarEventTimeMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ProposeCalendarEventTimeInput) =>
      proposeExternalCalendarEventTime(payload),

    // only the detail refreshes — a counter-proposal does not move the event on the grid
    onSettled: async () => {
      await client.invalidateQueries({ queryKey: [eventQueryKey] });
    },
  });
};
